import React from "react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import "./passwordInput.css";
type PropsType = {
  reference?: React.RefObject<HTMLInputElement | null>;
  value?: string;
  onChange?: (value: string) => void;
  pHolder: string;
  showPas: boolean;
  belowTx?: boolean;
  setShowPas: (val: boolean) => void;
};
const PasswordInput = ({
  reference,
  value,
  onChange,
  pHolder,
  showPas,
  setShowPas,
  belowTx = true,
}: PropsType) => {
  return (
    <>
      <div className="InputFields">
        <input
          placeholder={pHolder}
          type={showPas ? "text" : "password"}
          ref={reference}
          value={value}
          onChange={
            onChange ? (e) => onChange(e.target.value) : undefined
          }
          required
          className="ResetPasswordInput"
          pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,16}$"
        />
        {showPas ? (
          <AiFillEye
            size={18}
            onClick={() => setShowPas(!showPas)}
            className="ShowPasswordLogin"
            aria-label="Hide password"
          />
        ) : (
          <AiFillEyeInvisible
            size={18}
            onClick={() => setShowPas(!showPas)}
            className="ShowPasswordLogin"
            aria-label="Show password"
          />
        )}
      </div>
      {belowTx ? (
        <span className="PasswordDetails">
          Password must has at least 8 characters, that include at least 1
          lowercase character, 1 uppercase characters, 1 number and 1 special
          character in (!@#$%^&*)
        </span>
      ) : null}
    </>
  );
};

export default PasswordInput;
